export default __webpack_public_path__ + "580f325c5e111fa5332ac397ee6647d2.png";